var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecovery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3639 2.8014C4.65692 2.50837 5.05435 2.34375 5.46875 2.34375H14.8438C15.051 2.34375 15.2497 2.42606 15.3962 2.57257L20.8649 8.04132C21.0114 8.18784 21.0938 8.38655 21.0938 8.59375V21.0938C21.0938 21.5081 20.9291 21.9056 20.6361 22.1986C20.3431 22.4916 19.9456 22.6562 19.5312 22.6562H5.46875C5.05435 22.6562 4.65692 22.4916 4.3639 22.1986C4.07087 21.9056 3.90625 21.5081 3.90625 21.0938V3.90625C3.90625 3.49185 4.07087 3.09442 4.3639 2.8014ZM14.5201 3.90625L5.46875 3.90625L5.46875 21.0938H19.5312V8.91735L14.5201 3.90625Z",
    fill: "#00872D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8438 2.34375C15.2752 2.34375 15.625 2.69353 15.625 3.125V7.8125H20.3125C20.744 7.8125 21.0938 8.16228 21.0938 8.59375C21.0938 9.02522 20.744 9.375 20.3125 9.375H14.8438C14.4123 9.375 14.0625 9.02522 14.0625 8.59375V3.125C14.0625 2.69353 14.4123 2.34375 14.8438 2.34375Z",
    fill: "#00872D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9476 11.1663C12.2527 10.8612 12.7473 10.8612 13.0524 11.1663L15.7868 13.9007C16.0919 14.2058 16.0919 14.7005 15.7868 15.0056C15.4817 15.3106 14.987 15.3106 14.6819 15.0056L12.5 12.8236L10.3181 15.0056C10.013 15.3106 9.51829 15.3106 9.2132 15.0056C8.9081 14.7005 8.9081 14.2058 9.2132 13.9007L11.9476 11.1663Z",
    fill: "#00872D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 10.9375C12.9315 10.9375 13.2812 11.2873 13.2812 11.7188V17.9688C13.2812 18.4002 12.9315 18.75 12.5 18.75C12.0685 18.75 11.7188 18.4002 11.7188 17.9688V11.7188C11.7188 11.2873 12.0685 10.9375 12.5 10.9375Z",
    fill: "#00872D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecovery);
export default __webpack_public_path__ + "static/media/recovery.831f44d4a949cd3fb7263d5a7a2a4d8f.svg";
export { ForwardRef as ReactComponent };